import { render, staticRenderFns } from "./listofTopicsDetails.vue?vue&type=template&id=9e2fa554&scoped=true&"
import script from "./listofTopicsDetails.vue?vue&type=script&lang=js&"
export * from "./listofTopicsDetails.vue?vue&type=script&lang=js&"
import style0 from "./listofTopicsDetails.vue?vue&type=style&index=0&id=9e2fa554&prod&lang=less&scoped=true&"
import style1 from "./listofTopicsDetails.vue?vue&type=style&index=1&id=9e2fa554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2fa554",
  null
  
)

export default component.exports